import {versionService} from '../../helpers/versionService';

export const state = {
    getAllVersion : [],
    loading: false,
    versionCount: "",
    pagination : {},
    version: {
        ios_version: "",
        android_version: "",
        status: 1
    },
};
export const mutations = {

    getVersionListRequest(state) {
        state.loading = true;
    },
    getAllVersion(state, payload) {
        state.getAllVersion = payload.result.data;
        state.loading = false;
        state.pagination = payload.result;
        state.versionCount = payload.result.total;
    },
    getVersionListFailure(state) {
        state.loading = false;
    },
    getVersion(state, payload) {
        state.user = payload.result;
    },
};

export const actions = {

    async getVersions({dispatch, commit}, data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        commit("getVersionListRequest");
        await versionService.getVersion(data)
        .then(
            response => {
                commit('getAllVersion', response.data);
            },
            error => {
                commit("getVersionListFailure", error,{root:true});
                dispatch("alert/error", error, {root: true});
            }
        );
    },

    async addVersion({dispatch,commit}, data) {
        return new Promise((resolve) => {
            let token = JSON.parse(localStorage.getItem('token'));
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            versionService.addVersion(data)
            .then(
                response => {
                    dispatch('getAllVersion');
                    resolve(response);
                },
                error => {
                    commit("error",error);
                }
            );
        });
    },

    async deleteVersion({dispatch,commit}, data) {
        return new Promise((resolve) => {
            let token = JSON.parse(localStorage.getItem('token'));
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            versionService.deleteVersion(data)
            .then(
                response => {
                    dispatch('getAllVersion');
                    resolve(response);
                },
                error => {
                    commit("error",error);
                }
            );
        });
    },

    async getVersionById({dispatch, commit}, data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return new Promise((resolve) => {
            versionService.getVersionById(data)
            .then(
                response => {
                    commit('getVersion', response.data);
                    resolve(response);
                },
                error => {
                    dispatch("alert/error", error, {root: true});
                }
            );
        })
    },

    async editVersion({dispatch,commit}, data) {
        return new Promise((resolve) => {
            let token = JSON.parse(localStorage.getItem('token'));
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            versionService.editVersion(data)
            .then(
                response => {
                    dispatch('getAllVersion');
                    resolve(response);
                },
                error => {
                    commit("error",error);
                }
            );
        });
    },
};

export const getters = {
    getAllVersion: state => state.getAllVersion,
    loading: state => state.loading,
    versionCount: state => state.versionCount,
    pagination: state => state.pagination,
    versionData: state => state.getVersion
};